import { jsx as _jsx } from "react/jsx-runtime";
import { Route as BaseRoute } from "react-router-dom";
const Route = ({ component, exact, path }) => (_jsx(BaseRoute, { component: component, exact: exact, path: path }));
export default Route;
